import { render, staticRenderFns } from "./AvSkeletonTable.vue?vue&type=template&id=1629bcbb&scoped=true"
import script from "./AvSkeletonTable.vue?vue&type=script&lang=js"
export * from "./AvSkeletonTable.vue?vue&type=script&lang=js"
import style0 from "./AvSkeletonTable.vue?vue&type=style&index=0&id=1629bcbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1629bcbb",
  null
  
)

export default component.exports